import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUi from "element-ui"
import "./style/reset.css"
import "./style/layout.css"
import './style/element-variables.scss'
import "@/utils/bus"
import "./permission"
import BaiduMap from 'vue-baidu-map'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.config.productionTip = false

Vue.use(ElementUi)
Vue.use(BaiduMap, {
  ak: '9xrz1uTdgINCrauth3iU8HR2DSAsKnB0' // 这里填入你在百度地图开放平台申请的API Key
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
